import { Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import { formateISODateToStr } from "@/utils";

const Header = ({ createdDate, config }) => {
  const styles = StyleSheet.create({
    header: {
      marginBottom: 28,
    },
    headerInner: {
      paddingBottom: 12,
      borderBottom: "1px solid #BBBBBB",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    titleWrap: {
      flexDirection: "row",
      gap: 6,
    },
    title: {
      fontWeight: 600,
      fontSize: 13,
      lineHeight: 1.4,
      color: "#777777",
    },
    date: {
      fontWeight: 400,
      fontSize: 9,
      lineHeight: 1,
      color: "#777777",
      padding: "1px 5px",
      backgroundColor: "#F7F7F7",
      backdropFilter: "blur(2px)",
      borderRadius: 4,
      alignSelf: "baseline",
      border: "1px solid #e9e9e9",
      verticalAlign: "center",
    },

    logo: {
      width: 110,
      height: 22,
    },

    logoPlaceholder: {
      width: 107,
      height: 35,
    },
  });

  return (
    <View style={styles.header} fixed>
      <View style={styles.headerInner}>
        <View style={styles.titleWrap}>
          <Text style={styles.title}>Паспорт объекта</Text>
          <Text style={styles.date}>{formateISODateToStr(createdDate)}</Text>
        </View>

        <View style={styles.logoWrap}>
          {config?.logo_docs_path && (
            <Image
              src={config.logo_docs_path}
              style={
                !config?.is_red_logo ? styles.logo : styles.logoPlaceholder
              }
            />
          )}
        </View>
      </View>
    </View>
  );
};

export default Header;
